import { render, staticRenderFns } from "./FeaturedBlog.vue?vue&type=template&id=05c218ae&scoped=true&lang=pug&"
import script from "./FeaturedBlog.vue?vue&type=script&lang=js&"
export * from "./FeaturedBlog.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBlog.vue?vue&type=style&index=0&id=05c218ae&prod&lang=scss&scoped=true&"
import style1 from "./FeaturedBlog.vue?vue&type=style&index=1&id=05c218ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c218ae",
  null
  
)

export default component.exports